<h2 mat-dialog-title class="d-flex justify-content-between align-items-center">
  <span>{{ 'PHARMACY.NEW_STOCK_IN' | translate }}</span>
  <button mat-icon-button (click)="onClose()">
    <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
  </button>
</h2>

<!-- Reference Field (header, outside scrollable content) -->
<div class="stock-in-header" [formGroup]="stockInForm">
  <div class="row">
    <div class="col-lg-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'PHARMACY.REFERENCE_INVOICE' | translate }}</mat-label>
        <input matInput formControlName="reference" />
      </mat-form-field>
    </div>
  </div>
</div>

<mat-dialog-content>
  <mat-tab-group>
    <mat-tab [label]="'PHARMACY.STOCK_IN_ITEMS' | translate">
      <div [formGroup]="stockInForm" class="tab-layout add-invoice-list">
        <div class="invoice-table-scroll">
          <div class="table-responsive">
            <table class="table table-hover b-1 rounded w-100">
              <thead>
                <tr>
                  <th class="col-sno text-center">S.No</th>
                  <th class="col-drug">{{ 'PHARMACY.DRUG_NAME' | translate }}</th>
                  <th class="col-batch">{{ 'PHARMACY.BATCH_NO' | translate }}</th>
                  <th class="col-expiry">{{ 'PHARMACY.EXPIRY_DATE' | translate }}</th>
                  <th class="col-qty text-center">{{ 'PHARMACY.QTY' | translate }}</th>
                  <th class="col-price text-center">{{ 'PHARMACY.PURCHASE_PRICE' | translate }}</th>
                  <th class="col-price text-center">{{ 'PHARMACY.SELLING_PRICE_MRP' | translate }}</th>
                  <th class="col-action"></th>
                </tr>
              </thead>
              <tbody formArrayName="items">
                @for (row of items.controls; track row; let i = $index; let last = $last) {
                <tr [formGroupName]="i">
                  <td class="col-sno text-center">{{ i + 1 }}</td>
                  <td class="col-drug">
                    <mat-form-field appearance="outline" class="hide-hint w-100">
                      <input type="text" matInput formControlName="drugCtrl" [matAutocomplete]="autoStockDrug" />
                      <mat-autocomplete #autoStockDrug="matAutocomplete" [displayWith]="displayDrugLookup"
                        (optionSelected)="onDrugSelected($event.option.value, items.at(i))">
                        <mat-option *ngFor="let drug of getFilteredDrugsForRow(i) | async" [value]="drug">
                          {{ drug.drugName }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </td>
                  <td class="col-batch">
                    <mat-form-field appearance="outline" class="hide-hint w-100">
                      <input matInput formControlName="batchNo" />
                    </mat-form-field>
                  </td>
                  <td class="col-expiry">
                    <mat-form-field appearance="outline" class="hide-hint">
                      <input matInput [matDatepicker]="expiryPicker" formControlName="expiryDate" [min]="minDate"/>
                      <mat-datepicker-toggle matSuffix [for]="expiryPicker"></mat-datepicker-toggle>
                      <mat-datepicker #expiryPicker></mat-datepicker>
                    </mat-form-field>
                  </td>
                  <td class="col-qty">
                    <mat-form-field appearance="outline" class="hide-hint w-100">
                      <input type="number" matInput formControlName="quantity" min="1" class="text-right" />
                    </mat-form-field>
                  </td>
                  <td class="col-price">
                    <mat-form-field appearance="outline" class="hide-hint w-100">
                      <input type="number" matInput formControlName="purchasePrice" class="text-right" />
                    </mat-form-field>
                  </td>
                  <td class="col-price">
                    <mat-form-field appearance="outline" class="hide-hint w-100">
                      <input type="number" matInput formControlName="sellingPrice" class="text-right" />
                    </mat-form-field>
                  </td>
                  <td class="col-action whitespace-nowrap">
                    <button mat-icon-button color="primary" class="text-left" *ngIf="last && isChargeSelected(row)"
                      (click)="onAddRow()">
                      <i-tabler name="plus" class="icon-18 d-flex"></i-tabler>
                    </button>
                    <button mat-icon-button color="warn" *ngIf="!isChargeSelected(row) && i > 0"
                      (click)="onRemoveRow(i)">
                      <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
                    </button>
                    <button mat-icon-button color="primary" *ngIf="isChargeSelected(row)" (click)="onRemoveRow(i)">
                      <i-tabler name="trash" class="icon-18 d-flex"></i-tabler>
                    </button>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions>
  <div class="justify-content-between m-b-10 w-100">
    <div class="col-12 text-right">
      <a mat-stroked-button color="primary" (click)="onClose()">
        {{ 'BUTTON.BTN_CLOSE' | translate }}
      </a>
      <button mat-flat-button color="primary" (click)="onSave()">
        {{ 'BUTTON.BTN_SAVE' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-actions>